import { TFileVersion } from '@modules/files';
import { TDraft, TVersion } from '@modules/documents';
import { TInlineBlockDraft, TInlineBlockVersion } from '@modules/inlineBlocks';

const getVersionId = (version: TVersion | TFileVersion | TInlineBlockVersion | TDraft | TInlineBlockDraft) => {
  return (version as TVersion | TFileVersion | TInlineBlockVersion).id || 'draft';
};

export default getVersionId;
